define('gigaset_recurring/components/checkout/provider/billwerk/plugins/addressTypes/step',[
	"jquery",
	"lodash",
	"gigaset_recurring/classes/provider/billwerk/steps/address/_abstract",
	"cartware/jquery/bem",
	"cartware/components/Registry",
	"cartware/components/Logger",
	"text!shoptheme/templates/customer/address.html",
	"jquery-serialize-object"
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Registry,
	Logger,
	AddressHtml
) {

	function AddressTypeStep(id) {
		AbstractStep.call(this);

		this.logger			= Logger.getLogger("gigaset_recurring.address");
		this.rootElement	= $('#step-address-type-' + id);
		this.id				= id;
		this.formDataKey	= 'address-type';
	}

	AddressTypeStep.prototype = _.create(new AbstractStep, {
		constructor: AddressTypeStep,

		collectFormData: function() {
			var result = AbstractStep.prototype.collectFormData.apply(this, arguments);
			_.set(result[this.formDataKey], 'address-type', this.id);
			return result;
		}
	});

	return AddressTypeStep;

});
